import { render, staticRenderFns } from "./LogsTab.vue?vue&type=template&id=ad372324&"
import script from "./LogsTab.vue?vue&type=script&lang=ts&"
export * from "./LogsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports